

































































































































































































































































































































































import PowerConditionerDialog from "@/components/dialog/powerConditioner.vue";
import VersionCheckDialog from "@/components/dialog/versionCheck.vue";
import FirewareUpgradeDialog from "@/components/dialog/firewareUpgrade.vue";
import FirewareBatchUpgradeDialog from "@/components/dialog/firewareBatchUpgrade.vue";
import LineChart from "@/components/chart/LineChart.vue";
import Pagination from "@/components/Pagination/index.vue"; // Secondary package based on el-pagination
import { Vue, Component } from "vue-property-decorator";
import path from "path";
import { deepClone } from "@/utils";
import { asyncRoutes } from "@/router";
import i18n from "@/lang";
import xlsx from "xlsx";
import mqtt from "mqtt";
import { globalData } from "@/utils/config";
import {
  meters,
  childMeters,
  queryMeter,
  QueryMeterReq,
  updateMeter,
  setParentMeter,
  SetMeterParentReq,
  SearchMeterReq,
  GetMetersReq,
  SendDataReq,
  sendData,
  meterTypes,
  BatchBindMeterCostReq,
  BatchBindUserReq,
  batchBindMeterCost,
  batchBindUser,
  deleteMeter,
  DeleteMeterReq,
  MeterTypeReq,
} from "@/api/meter";
import { RouteConfig } from "vue-router";
import {
  ResCode,
  PagingReq,
  Meter,
  User,
  MeterCost,
  Company,
  Address,
  MeterType,
  Fireware,
  MeterVersionInfomation,
} from "@/api/baseDefine";
import { queryMeterCost, meterCosts, GetMeterCostReq } from "@/api/meterCost";
import { formatDate } from "@/utils/dateUtil";
import { ElTree, TreeData } from "element-ui/types/tree";
import { UserModule } from "@/store/modules/user";
import { ElStep } from "element-ui/types/step";
import { queryUser, QueryUserReq } from "../../api/user";
import { getAddresses, GetAddress } from "../../api/address";
import { GetMeterReq, getMeterData, History } from "../../api/home";
import { QueryMeterCostReq } from "../../api/meterCost";
import { Getter } from "vuex";
import { CompanyCommonReq, geCompanys } from "@/api/company";
import { FirewareCommonReq, geFirewares } from "@/api/fireware";

/**
 * 包含所有功能的表单
 *
 * @export
 * @class ComplexTable
 * @extends {Vue}
 */
@Component({
  components: {
    Pagination,
    LineChart,
    PowerConditionerDialog,
    VersionCheckDialog,
    FirewareUpgradeDialog,
    FirewareBatchUpgradeDialog,
  },
})
export default class MeterFirewareList extends Vue {
  private meterTypeUnits: string[] = ["m³", "kWh", "m³", "MWh", "kWh", "kWh"];
  private firewareID = "";
  private firewareMeterTypeID = 0;

  private meterTypes: string[] = [];
  private isSearch = false;
  private editMeter: Meter = <Meter>{};
  private queryMeterTypes: MeterType[] = [];
  private queryCompanys: Company[] = [];
  private queryFirewares: Fireware[] = [];
  private queryUsers: User[] = [];
  private queryInstallUsers: User[] = [];
  private queryMeters: Meter[] = [];
  private queryMeterCosts: MeterCost[] = [];
  private addressSearchType = 1;
  private queryAddresses: Address[] = [];

  private queryProviceList: string[] = [];
  private queryCityList: string[] = [];
  private queryStreetList: string[] = [];

  private searchMeter: Meter = <Meter>{};
  private loading: boolean = false;

  private list: Meter[] = [];
  private listLoading: boolean = true;

  private dialogType = "edit"; //判断弹出层是添加还是编辑
  private total = 0;
  private parentMeter: string = "";
  private roleKey = "";

  private batchParentMeterID = "";
  private batchBindUserID = "";
  private batchBindMeterCostName = "";
  private batchBindNextCostName = "";
  private batchBindNextCostDate = "";
  private selectItems = new Array<Meter>();
  private selectMeters = new Array<Meter>();
  private adminID = 0;

  private listQuery: GetMetersReq = <GetMetersReq>{
    page: 1,
    pageSize: 10,
  };

  private showBatch = false;
  public onSelectOwnUser(b) {
    if (b) {
      this.queryOwnUser("");
    }
  }
  public onSelectInstallUser(b) {
    if (b) {
      this.queryInstallUser("");
    }
  }

  public onSelectCompany(b) {
    if (b) {
      this.queryCompany("");
    }
  }

  public onSelectFireware(b) {
    if (b) {
      this.queryFireware("");
    }
  }

  public onSelectParentMeterID(b) {
    if (b) {
      this.queryMeter("");
    }
  }

  public onSelectChangeProvince(b) {
    if (b) {
      this.addressSearchType = 2;
      this.queryAddress("");
    }
  }

  public onSelectChangeCity(b) {
    if (b) {
      this.addressSearchType = 3;
      this.queryAddress("");
    }
  }
  public onSelectChangeDetail(b) {
    if (b) {
      this.addressSearchType = 4;
      this.queryAddress("");
    }
  }

  public async queryMeter(query: string) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await meters(<GetMetersReq>{ meter: { meterID: query } });
      if (res.code === ResCode.SUCCESS) {
        this.queryMeters = res.data.meters.list;
        this.loading = false;
      }
    }
  }

  public async queryMeterType() {
    this.meterTypes = <string[]>(<any>this.$t("meterTypeArray"));
    this.loading = true;
    const res = await meterTypes(<MeterTypeReq>{});
    if (res.data.meterTypes.list.length > 0) {
      res.data.meterTypes.list.push(<MeterType>{ id: 7 });
    }
    if (res.code === ResCode.SUCCESS) {
      this.queryMeterTypes = res.data.meterTypes.list;
      for (let type of this.queryMeterTypes) {
        type.name = this.meterTypes[type.id - 1];
      }
      this.loading = false;
    }
  }
  public async queryMeterCost(query: string) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await meterCosts(<GetMeterCostReq>{
        page: 1,
        pageSize: 10,
        name: query,
      });
      if (res.code === ResCode.SUCCESS) {
        this.queryMeterCosts = res.data.meterCostData.list;
        this.loading = false;
      }
    }
  }
  public async queryOwnUser(query) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await queryUser(<QueryUserReq>{
        queryUserType: 0,
        query: query,
      });
      if (res.code === ResCode.SUCCESS) {
        this.queryUsers = res.data.users.list;
        this.loading = false;
      }
    }
  }

  public async queryAddress(query: string) {
    let req: GetAddress = <GetAddress>{};
    let address: Address = <Address>{};
    req.page = 1;
    req.pageSize = 10;
    req.address = address;
    req.searchType = this.addressSearchType;
    this.loading = true;
    address.country = query;
    address.province = query;
    address.city = query;
    address.detail = query;
    const res = await getAddresses(req);
    if (res.code === ResCode.SUCCESS) {
      this.queryAddresses = res.data.addressesData.list;
      this.queryProviceList = [];
      this.queryCityList = [];
      this.queryStreetList = [];
      for (let address of this.queryAddresses) {
        if (this.queryProviceList.indexOf(address.province) < 0) {
          this.queryProviceList.push(address.province);
        }
        if (this.queryCityList.indexOf(address.city) < 0) {
          if (
            !this.searchMeter.province ||
            address.province == this.searchMeter.province
          ) {
            this.queryCityList.push(address.city);
          }
        }
        if (this.queryStreetList.indexOf(address.detail) < 0) {
          if (!this.searchMeter.city || address.city == this.searchMeter.city) {
            this.queryStreetList.push(address.detail);
          }
        }
      }
      this.loading = false;
    }
  }

  public async queryCompany(query) {
    let req: CompanyCommonReq = <CompanyCommonReq>{};
    let company: Company = <Company>{};
    req.page = 1;
    req.pageSize = 10;
    company.name = query;
    req.company = company;
    this.loading = true;
    const res = await geCompanys(req);
    if (res.code === ResCode.SUCCESS) {
      this.queryCompanys = res.data.companys.list;
      this.loading = false;
    }
  }

  private async queryFireware(query) {
    let req: FirewareCommonReq = <FirewareCommonReq>{};
    let fireware: Fireware = <Fireware>{};
    req.page = 1;
    req.pageSize = 10;
    fireware.name = query;
    req.fireware = fireware;
    this.loading = true;
    const res = await geFirewares(req);
    if (res.code === ResCode.SUCCESS) {
      this.queryFirewares = res.data.firewares.list;
      this.loading = false;
    }
  }
  public async queryInstallUser(query) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await queryUser(<QueryUserReq>{
        queryUserType: 1,
        query: query,
      });
      if (res.code === ResCode.SUCCESS) {
        this.queryInstallUsers = res.data.users.list;
        this.loading = false;
      }
    }
  }

  public loadChild(tree, treeNode, resolve) {
    childMeters({ meterID: tree.id }).then((res) => {
      let childs: Meter[] = res.data.meters.list;
      resolve(childs);
    });
  }

  public async getList() {
    let req = <GetMetersReq>{
      page: this.listQuery.page,
      pageSize: this.listQuery.pageSize,
    };
    if (this.isSearch) {
      req.meter = this.searchMeter;
    }
    const res = await meters(req);
    if (res.code === ResCode.SUCCESS) {
      this.roleKey = "";
      this.list = res.data.meters.list;
      this.total = res.data.meters.totalCount;
    }
    this.listLoading = false;
  }

  public async searchMeters() {
    this.isSearch = true;
    this.listQuery.page = 1;
    this.getList();
  }

  public handleSelectionChange(val) {
    this.selectItems = val;
    if (!!this.selectItems && this.selectItems.length > 0) {
      this.showBatch = true;
    } else {
      this.showBatch = false;
    }
  }

  public async clickReset() {
    this.searchMeter = <Meter>{};
  }

  public handleClickVersionCheck() {
    let versionCheckRef = this.$refs.versionCheckRef as any;
    versionCheckRef.clickShow();
  }
  public handleclickUpgrade() {
    let firewareUpgrade = this.$refs.firewareUpgrade as any;
    firewareUpgrade.clickShow();
  }

  public handleClickFileUpgrade() {
    let firewareUpgrade = this.$refs.firewareUpgrade as any;
    firewareUpgrade.clickShow([]);
  }

  public handleclickBatchUpgrade() {
    let firewareBatchUpgradeRef = this.$refs.firewareBatchUpgradeRef as any;
    firewareBatchUpgradeRef.clickShow();
  }
  public closeBatchDialog() {
    if (this.batchSet) {
      this.getList();
    }
  }
  private batchSet = false;

  public handleSelectFireware(firewareID) {
    for (let f of this.queryFirewares) {
      if (f.id == firewareID) {
        this.firewareMeterTypeID = f.meterTypeID;
      }
    }
  }

  private created() {
    this.adminID = UserModule.id;
    this.queryMeterType();
    this.getList();
    this.connectMqtt();
  }

  private destroyed() {
    this.disConnectMqtt();
  }

  private mqttClient: mqtt.MqttClient = <mqtt.MqttClient>{};
  private connectMqtt() {
    console.log("connectMqtt");
    var client;
    const options = {
      connectTimeout: 40000,
      clientId: "",
      username: "",
      password: "",
      clean: true,
    };
    this.mqttClient = mqtt.connect(globalData.mqttHost, options);

    // mqtt连接
    this.mqttClient.on("connect", (e) => {
      console.log("连接成功:");
      this.mqttClient.subscribe(
        "Custom/to_client/meter_version/#",
        { qos: 1 },
        (error) => {
          if (!error) {
            console.log("订阅成功");
          } else {
            console.log("订阅失败");
          }
        }
      );
    });
    // 接收消息处理
    this.mqttClient.on("message", (topic, message) => {
      let meterVersionInfomation: MeterVersionInfomation = JSON.parse(
        message.toString()
      );
      console.log(
        "收到来自",
        topic,
        "的消息",
        meterVersionInfomation,
        this.list.length
      );
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].meterID == meterVersionInfomation.meterId) {
          console.log("11111111111111111111111111111111--------------");
          this.list[i].moduleId = meterVersionInfomation.moduleId;
          this.list[i].moduleVersion =
            meterVersionInfomation.moduleMainFirmwareVersion;
          //  this.$set(this.tableData, this.tableData[i].i, this.tableData[i]);
          break;
        }
      }
    });
    // 断开发起重连
    this.mqttClient.on("reconnect", (error) => {
      console.log("正在重连:", error);
    });
    // 链接异常处理
    this.mqttClient.on("error", (error) => {
      console.log("连接失败:", error);
    });
  }

  private disConnectMqtt() {
    console.log("disConnectMqtt");
    this.mqttClient.end();
  }
}
